import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CinchCardComponent } from '../cinch-card/cinch-card.component';

@Component({
  selector: 'cinch-card-hero',
  templateUrl: './cinch-card-hero.component.html',
  styleUrl: '../base-cinch-card.component.scss'
})
export class CinchCardHeroComponent extends CinchCardComponent {
  @Input() heroImageMobile: string = '';
  @Input() heroImageTablet: string = '';
  @Input() heroImageDesktop: string = '';
  @Input() heroImageAlt: string = '';
  @Input() heroBackgroundColor: string = 'rgba(0,0,0,0)';
  @Input() heroPadding:string = '0px';
}
